import React from "react";
import { AppResources } from "@/constants";
import { Avatar, Button, Grid, Text } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { IconCheck, IconProgress } from "@tabler/icons-react";

interface HowItWorksItemProps {
  title: string;
  description: React.ReactNode;
  span: number;
  centerContent?: boolean;
}

const howItWorksData: HowItWorksItemProps[] = [
  {
    title: "Featured Payments",
    description: "Request and receive client payments easily.",
    span: 6,
  },
  {
    title: "Simple Tracking",
    description: "Stay on top of all your requested payments.",
    span: 6,
  },
  {
    title: "Automated Payments",
    description: (
      <>
        Clients get notified <br /> if you requested a payment.
      </>
    ),
    span: 12,
    centerContent: true,
  },
];

const HowItWorksItem: React.FC<HowItWorksItemProps> = ({
  title,
  description,
  span,
  centerContent = false,
}) => {
  return (
    <Grid.Col span={span} className={centerContent ? "centered-item" : ""}>
      <div className="tax-pro-payments-subheader-item">
        <Avatar variant="filled" color="#0077cc" size="sm">
          <IconCheck size={20} />
        </Avatar>
        <Text>
          <strong>{title}: </strong>
          {description}
        </Text>
      </div>
    </Grid.Col>
  );
};

interface PaymentWelcomeProps {
  handleCreateStripeIntegration: () => Promise<void>;
  isLoading: boolean;
  isError: boolean;
  error?: any;
  isInProgresson?: boolean;
}

const PaymentWelcome: React.FC<PaymentWelcomeProps> = ({
  handleCreateStripeIntegration,
  isLoading,
  isError,
  error,
  isInProgresson,
}) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  return (
    <>
      <div className="tax-pro-payments-header">
        <img className="banner-img" src={AppResources.wallet} alt="vid-lib" />
        <h1>Get Paid Faster with SmartWiz!</h1>
        <Text>
          Now you can request and track client payments - all within Smartwiz!
          Be among <strong>the first</strong> to <br />
          access this powerful new feature.
        </Text>

        <Button
          color="#0077cc"
          size="lg"
          mt="lg"
          mb="lg"
          radius="md"
          onClick={handleCreateStripeIntegration}
          loading={isLoading}
          variant={isInProgresson ? "light" : "filled"}
          leftSection={
            isInProgresson && <IconProgress size={20} color="#0077cc" />
          }
        >
          {isInProgresson ? "Continue Onboarding" : "Create Payment Account"}
        </Button>

        {isError && (
          <div>Error loading Stripe integration info: {error?.message}</div>
        )}
      </div>

      <div className="tax-pro-payments-subheader">
        <h2>How it works</h2>
        <Grid w="70%" className="tax-pro-payments-subheader-grid" gutter="md">
          {howItWorksData.map((item, index) => (
            <HowItWorksItem
              key={index}
              {...item}
              span={isMobile ? 12 : item.span}
            />
          ))}
        </Grid>
        <Text size="sm" c="dimmed" mt="lg" p="sm">
          SmartWiz applies a 3.9% + $5 service fee to every payment transaction.
        </Text>
      </div>
    </>
  );
};

export default PaymentWelcome;
